var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "datev",
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 22.5H7.59846V20.6658H24.159V6.91575H19.5579V2.33425H9.43668V8.75H7.5957V0.5H22.238L26 4.2455V22.5ZM21.3989 5.08425H24.159V5.0045L21.4789 2.33425H21.3989V5.08425Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35547 17.7612H5.5009L7.06311 13.5014L8.38243 16.9527H6.86715V17.7612H9.8094L7.73933 12.5059H6.43105L4.35547 17.7612ZM8.94549 12.5032V13.3832H10.6126V17.7639H11.7691V13.3749H13.4527V12.5004H8.94549V12.5032ZM13.8529 12.4922V17.7612H17.488V16.8729H15.0232V15.4374H17.2285V14.5519H15.0177V13.3639H17.3803V12.4922H13.8529ZM17.6563 12.5224H18.8514L20.3032 16.7272L21.4652 13.3529H20.1266V12.5252H22.895L20.9132 17.7639H19.6657L17.6563 12.5224Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.5078H1.67813C1.75541 12.5848 4.59554 12.1531 4.56794 15.0681C4.63418 18.0243 1.52633 17.7768 1.52633 17.7768H0V12.5078ZM1.4518 13.4181H1.10955V16.8886H1.38832C2.02866 16.8996 3.47219 16.7621 3.41146 15.0296C3.39214 13.4593 2.08938 13.3988 1.4518 13.4181Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatev);
export default __webpack_public_path__ + "static/media/datev.d56ce2847ee9a29b2202d7df25be8f78.svg";
export { ForwardRef as ReactComponent };